import React from "react";
import styles from "./MainApp.organisms.Dashboard.LineChart.module.scss";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import i18n from "i18n";

const getOptions = (series, xCategories) => {
  return {
    chart: {
        type: 'line',
        height: '250px'
    },
    title: {
        text: null
    },
    yAxis: {
        title: {
            text:  null
        }
    },
    xAxis: {
        categories: xCategories
    },
    legend: {
        enabled: false,
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
    },

    plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
        }
    },

    series: series,

    responsive: {
        rules: [{
            condition: {
                maxWidth: 500
            },
            chartOptions: {
                legend: {
                    layout: 'horizontal',
                    align: 'center',
                    verticalAlign: 'bottom'
                }
            }
        }]
    }

};
};
const LineChart = ({
  series = [{
    name: i18n.t("sales"),
    data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175]
  }],
  xCategories = [i18n.t("months.numeric.1"), i18n.t("months.numeric.2"),
                 i18n.t("months.numeric.3"), i18n.t("months.numeric.4"),
                 i18n.t("months.numeric.5"), i18n.t("months.numeric.6"),
                 i18n.t("months.numeric.7"), i18n.t("months.numeric.8"),
                 i18n.t("months.numeric.9"), i18n.t("months.numeric.10"),
                 i18n.t("months.numeric.11"), i18n.t("months.numeric.12")],
}) => {
  return (
    <div style={{position: 'relative', height: '100%'}}>
          <HighchartsReact
            highcharts={Highcharts}
            options={getOptions(series, xCategories)}
          />
        </div>
  );
};

export default LineChart;
